import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

interface UserSession {
  userId: string;
  email: string;
  name: string;
  role: string;
}

function Dashboard() {
  const [session, setSession] = useState<UserSession | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check authentication by calling a protected API endpoint
    const checkAuth = async () => {
      try {
        const apiUrl = import.meta.env.VITE_API_URL || '';
        const response = await fetch(`${apiUrl}/api/admin/users`, {
          credentials: 'include', // Include cookies
        });

        if (response.status === 401 || response.status === 403) {
          // Not authenticated - redirect to login
          window.location.href = `${apiUrl}/auth/login`;
          return;
        }

        if (response.ok) {
          // Authenticated - extract user info from response
          // For now, just mark as authenticated
          setSession({
            userId: 'user',
            email: 'user@example.com',
            name: 'Admin User',
            role: 'admin',
          });
        } else {
          // Redirect to login on other errors
          window.location.href = `${apiUrl}/auth/login`;
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        window.location.href = `${import.meta.env.VITE_API_URL}/auth/login`;
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const handleLogout = async () => {
    try {
      const apiUrl = import.meta.env.VITE_API_URL || '';
      await fetch(`${apiUrl}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });
      // Redirect to login
      window.location.href = `${apiUrl}/auth/login`;
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: '20px', fontFamily: 'sans-serif' }}>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1>Admin Dashboard</h1>
        <button onClick={handleLogout} style={{ padding: '8px 16px', cursor: 'pointer' }}>
          Logout
        </button>
      </div>
      {session && (
        <div style={{ marginTop: '20px' }}>
          <p><strong>Welcome, {session.name}!</strong></p>
          <p>Email: {session.email}</p>
          <p>Role: {session.role}</p>
        </div>
      )}
      <div style={{ marginTop: '20px' }}>
        <h2>Dashboard</h2>
        <p>Admin dashboard is being set up. Please check back soon.</p>
        <p>API URL: {import.meta.env.VITE_API_URL}</p>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/')({
  component: Dashboard,
});
